module.exports = __webpack_public_path__ + "media/images/emblems/Ursenbach-coat_of_arms-249e40a75181294eb7376e0f1959a0f4.svg";